export default __webpack_public_path__ + "static/media/ic-rpm-nav-icon.2c1dcf38.svg";